import create from 'zustand';
import { User } from '../../types/auth.types';

interface UseFranchiseeAliasType {
  alias: User | null;
  setAlias: (newUser: User | null) => void;
  removeAlias: () => void;
  actualUser: User | null;
  setActualUser: (newUser: User | null) => void;
  removeActualUser: () => void;
}

const useFranchiseeAlias = create<UseFranchiseeAliasType>()((set) => {
  let parsedAlias = null;
  const aliasInfo = window.sessionStorage.getItem('aliasInfo');
  if (aliasInfo) {
    try {
      parsedAlias = JSON.parse(aliasInfo);
    } catch (err) {
      console.log('Error parsing ', aliasInfo);
    }
  }
  return {
    alias: parsedAlias,
    setAlias: (newUser: User | null) => set(() => ({ alias: newUser })),
    removeAlias: () => {
      set({ alias: null });
      sessionStorage.removeItem('aliasInfo');
    },
    actualUser: null,
    setActualUser: (newUser: User | null) => set(() => ({ actualUser: newUser })),
    removeActualUser: () => set({ actualUser: null }),
  };
});

export default useFranchiseeAlias;
